import { IPlayHubStore } from "apps/BWW_PLAY_HUB/modules/utils/types";
import { createSelector } from "reselect";


export const getHunStats = (store: IPlayHubStore): IPlayHubStore['hub_stats'] => store.hub_stats;

export const getHubFilter = createSelector(
	[ getHunStats ],
	(hub_stats) => {
		return hub_stats.filter;
	}
);

export const getHubStats = createSelector(
	[ getHunStats ],
	(hub_stats): IPlayHubStore['hub_stats']["stats"] => {
		return hub_stats.stats;
	}
);

export const getHubStatsFetched = createSelector(
	[ getHunStats ],
	(hub_stats) => hub_stats.isFetched
);
